import React from 'react';

import _ from 'lodash'

import InputTextField from './InputTextField';
import InputSelectField from './InputSelectField';


class ParkerVehicleTableRow extends React.Component {
  _onInputValueChange(inputId) {
    return value => {
      const vehicle = _.cloneDeep(this.props.vehicle);
      vehicle.fields[inputId].value = value;

      this.props.onVehicleChange(vehicle);
    };
  }


  onRemoveVehicleClick = () => {
    this.props.onVehicleChange(null);
  }


  render() {
    const {
      vehicle,
      ident,
      fieldConfiguration,
      editMode,
      allowRemove
    } = this.props;

    return (
      <tr>
        <td>
          <InputTextField inputId={`parkchirp--parker--vehicle--${ident}--make`}
            value={vehicle.fields.make.value}
            onChange={this._onInputValueChange('make')}
            editMode={editMode}
          />
        </td>
        <td>
          <InputTextField inputId={`parkchirp--parker--vehicle--${ident}--model`}
            value={vehicle.fields.model.value}
            onChange={this._onInputValueChange('model')}
            editMode={editMode}
          />
        </td>
        <td>
          <InputTextField inputId={`parkchirp--parker--vehicle--${ident}--license`}
            value={vehicle.fields.license.value}
            onChange={this._onInputValueChange('license')}
            editMode={editMode}
          />
        </td>
        <td>
          <InputSelectField inputId={`parkchirp--parker--vehicle--${ident}--state`}
            options={[ {value: null, label: ''}, ...fieldConfiguration.state.options ]}
            value={vehicle.fields.state.value}
            onChange={this._onInputValueChange('state')}
            editMode={editMode}
          />
        </td>
        <td>
          {(allowRemove) &&
            <button type="button"
              className="parkchirp--button-as-link"
              onClick={this.onRemoveVehicleClick}>
              Remove
            </button>
          }
        </td>
      </tr>
    );
  }
}
export default ParkerVehicleTableRow;
